// import React, { useRef, useCallback } from "react";
// import Tooltip from "@material-ui/core/Tooltip";

// const AddressCell = React.memo(function AddressCell({
//   row,
//   header,
//   index,
//   fetchAddress,
//   classes,
//   getNestedValue,
//   getIconFromMap,
// }) {
//   const value = getNestedValue(row, header.keyName);

//   let lat = null,
//     lng = null;
//   if (typeof row?.location === "string" && row.location.includes(",")) {
//     [lat, lng] = row.location
//       .split(",")
//       .map((v) => parseFloat(v.trim()) || null);
//   }

//   const latitude = lat ?? row?.[header.lat] ?? "--";
//   const longitude = lng ?? row?.[header.lng] ?? "--";
//   const address = row?.address || `${latitude}, ${longitude}`;

//   const tooltipRef = useRef(null); // 🔥 No state, no re-render

//   const handleClick = useCallback(() => {
//     if (latitude !== "--" && longitude !== "--") {
//       fetchAddress(
//         latitude,
//         longitude,
//         index,
//         header?.keyName,
//         header?.keyName
//       );
//     }
//   }, [latitude, longitude, index, header, fetchAddress]);

//   const handleCopy = useCallback(
//     async (e) => {
//       e.stopPropagation();
//       try {
//         await navigator.clipboard.writeText(address);

//         if (tooltipRef.current) {
//           tooltipRef.current.innerText = "Copied";
//         }

//         setTimeout(() => {
//           if (tooltipRef.current) {
//             tooltipRef.current.innerText = "Copy";
//           }
//         }, 1000);
//       } catch (err) {
//         console.error("Failed to copy:", err);
//       }
//     },
//     [address]
//   );

//   const spanStyle = {
//     display: "flex",
//     alignItems: "center",
//     gap: 6,
//     cursor: "pointer",
//     whiteSpace: "pre-wrap",
//     minWidth: "250px",
//     maxWidth: "400px",
//   };

//   return (
//     <span style={spanStyle} onClick={handleClick}>
//       {!value && (
//         <Tooltip
//           title={<span ref={tooltipRef}>Copy</span>}
//           arrow
//           PopperProps={{
//             modifiers: [
//               {
//                 name: "offset",
//                 options: { offset: [0, -10] },
//               },
//             ],
//           }}
//           classes={{ tooltip: classes.tooltip }}
//         >
//           <span
//             onClick={handleCopy}
//             style={{
//               cursor: "copy",
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             {getIconFromMap(header?.isIcon)}
//           </span>
//         </Tooltip>
//       )}

//       {value || address}
//     </span>
//   );
// });

// export default AddressCell;

import React, { useRef, useCallback, useEffect, useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { AddressAction } from "../../actions/Address";

// 🔥 GLOBAL CACHE (shared across all rows)
const addressCache = {};

const AddressCell = React.memo(function AddressCell({
  row,
  header,
  index,
  classes,
  getNestedValue,
  getIconFromMap,
}) {
  const value = getNestedValue(row, header.keyName);

  let lat = null,
    lng = null;
  if (typeof row?.location === "string" && row.location.includes(",")) {
    [lat, lng] = row.location
      .split(",")
      .map((v) => parseFloat(v.trim()) || null);
  }

  const latitude = lat ?? row?.[header.lat];
  const longitude = lng ?? row?.[header.lng];
  const cacheKey = latitude && longitude ? `${latitude},${longitude}` : null;
  const fallbackText =
    latitude && longitude ? `${latitude}, ${longitude}` : "--";
  const tooltipRef = useRef(null);
  const [address, setAddress] = useState(
    cacheKey && addressCache[cacheKey] ? addressCache[cacheKey] : fallbackText,
  );

  const fetchAddress = useCallback(async () => {
    if (!cacheKey) return;

    // ✅ already cached
    if (addressCache[cacheKey]) {
      setAddress(addressCache[cacheKey]);
      return;
    }

    try {
      const res = await AddressAction.ConvertLatTngToAddress(
        latitude,
        longitude,
      );
      // console.log(res, "reshhhhhhh");

      if (res?.responseCode === 500 || res?.responseCode === 204) return;

      const resolved = res?.add || `${latitude}, ${longitude}`;

      addressCache[cacheKey] = resolved;
      setAddress(resolved);
    } catch (err) {
      console.error("Address fetch failed:", err);
    }
  }, [cacheKey, latitude, longitude]);

  useEffect(() => {
    fetchAddress();
  }, [fetchAddress]);

  // ✅ COPY address + lat,lng
  const handleCopy = useCallback(
    async (e) => {
      e.stopPropagation();

      const copyText =
        address && cacheKey ? `${address} | ${cacheKey}` : fallbackText;

      try {
        await navigator.clipboard.writeText(copyText);

        if (tooltipRef.current) tooltipRef.current.innerText = "Copied";

        setTimeout(() => {
          if (tooltipRef.current) tooltipRef.current.innerText = "Copy";
        }, 1000);
      } catch (err) {
        console.error("Copy failed:", err);
      }
    },
    [address, cacheKey, fallbackText],
  );

  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "pre-wrap",
        minWidth: 250,
        maxWidth: 400,
      }}
    >
      {!value && (
        <Tooltip
          title={<span ref={tooltipRef}>Copy</span>}
          arrow
          classes={{ tooltip: classes.tooltip }}
        >
          <span
            onClick={handleCopy}
            style={{ cursor: "copy", display: "flex" }}
          >
            {getIconFromMap(header?.isIcon)}
          </span>
        </Tooltip>
      )}

      {address}
    </span>
  );
});

export default AddressCell;
